import { PERMISSIONS } from '../../constants';
import list from './PaymentList';

export default {
  list,
  name: 'payments',
  permissions: [PERMISSIONS.LIST_PAYMENTS]
}